import React, { useState, useEffect } from "react";
import ExpenseEntryModal from "./ExpenseEntryModal";
import "../styles/Expense.css";
import API_URL from "../apiConfig";

const DEFAULT_HEADS = [
  "Printing & Station",
  "Office Expenses",
  "Rent",
  "Utilities",
  "Travel",
  "Maintenance",
  "Books"
];

export default function ManageExpense({ token, user }) {
  const [expenses, setExpenses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editExpense, setEditExpense] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [heads, setHeads] = useState([]);

  const loadHeads = () => {
    try {
      const saved = JSON.parse(localStorage.getItem("expense_heads") || "[]");
      const merged = Array.from(new Set([...DEFAULT_HEADS, ...saved]));
      setHeads(merged);
    } catch {
      setHeads(DEFAULT_HEADS.slice());
    }
  };

  // Corrected endpoint here
  const fetchExpenses = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_URL}/api/income_expense/expense`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error("Failed to fetch expenses");
      const data = await res.json();
      // data from backend already formatted date as dd-mm-yyyy; normalize to ISO-like for table
      setExpenses(Array.isArray(data) ? data : []);
    } catch (err) {
      setError("Unable to load expenses.");
      setExpenses([]);
      /* eslint-disable no-console */
      console.error("fetchExpenses error", err);
      /* eslint-enable no-console */
    }
    setLoading(false);
  };

  useEffect(() => {
    loadHeads();
    fetchExpenses();
    // eslint-disable-next-line
  }, [token]);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this expense record?")) return;
    try {
      const res = await fetch(`${API_URL}/api/income_expense/expense/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error("Delete failed");
      fetchExpenses();
    } catch (err) {
      alert("Failed to delete. See console.");
      console.error(err);
    }
  };

  const handleAddHead = (newHead) => {
    if (!newHead || !newHead.trim()) return;
    const trimmed = newHead.trim();
    const saved = JSON.parse(localStorage.getItem("expense_heads") || "[]");
    if (!saved.includes(trimmed)) {
      saved.push(trimmed);
      localStorage.setItem("expense_heads", JSON.stringify(saved));
    }
    loadHeads();
  };

  const refreshExpenses = fetchExpenses;

  return (
    <div className="expense-container">
      <h2>Manage Expense</h2>
      <div style={{ marginBottom: 8 }}>
        <button className="expense-add-btn" onClick={() => { setEditExpense(null); setShowModal(true); }}>
          + Add Expense
        </button>
      </div>

      {showModal && (
        <ExpenseEntryModal
          token={token}
          expense={editExpense}
          editMode={!!editExpense}
          onClose={() => { setShowModal(false); setEditExpense(null); }}
          onSave={() => { setShowModal(false); setEditExpense(null); refreshExpenses(); }}
          user={user}
          heads={heads}
          onAddHead={handleAddHead}
        />
      )}

      {loading ? <div>Loading...</div> : error ? <div style={{ color: "red" }}>{error}</div> : (
        <table className="expense-table">
          <thead>
            <tr>
              <th>Voucher No</th>
              <th>Date</th>
              <th>Head</th>
              <th>Particulars</th>
              <th>Reference</th>
              <th>Amount</th>
              <th>Mode</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {expenses.length === 0 ? (
              <tr><td colSpan={8} style={{ textAlign: "center" }}>No expense records found.</td></tr>
            ) : expenses.map(exp => (
              <tr key={exp.id}>
                <td>{exp.voucher_no}</td>
                <td>{exp.date ? exp.date.slice(0, 10) : ""}</td>
                <td>{exp.account_head}</td>
                <td>{exp.particulars}</td>
                <td>{exp.reference}</td>
                <td>₹{Number(exp.amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
                <td>{exp.mode}</td>
                <td>
                  <button className="expense-edit-btn" onClick={() => { setEditExpense(exp); setShowModal(true); }}>Edit</button>
                  <button className="expense-delete-btn" onClick={() => handleDelete(exp.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}